<template>
  <el-container v-loading="isLoading">
    <el-header class="Edit-header">
      <el-page-header @back="close" content="充值 / 退款记录"></el-page-header>

    </el-header>
    <ul class="List-headr" style="padding-left: 20px">
      <li>
        <span>开始日期：</span>
        <el-date-picker v-model="startDay" type="date" placeholder="选择日期" size="small" format="yyyy-MM-dd" value-format="yyyyMMdd" :clearable="false" @change="myOption.restStartPage();getList();"></el-date-picker>
      </li>
      <li>
        <span>结束日期：</span>
        <el-date-picker v-model="endDay" type="date" placeholder="选择日期" size="small" format="yyyy-MM-dd" value-format="yyyyMMdd" :clearable="false" @change="myOption.restStartPage();getList();"></el-date-picker>
      </li>
      <li>
        <span>操作类型：</span>
        <el-select v-model="queryType" size="small" placeholder="请选择" @change="myOption.restStartPage();getList();">
          <el-option v-for="(item, index) in typeData" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </li>
    </ul>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="dateTime" label="时间" min-width="150px" :key="Math.random()"></el-table-column>
        <el-table-column prop="typeText" label="操作类型" min-width="120px" :key="Math.random()"></el-table-column>
        <el-table-column prop="balance" label="操作金额" min-width="120px" :key="Math.random()"></el-table-column>
        <el-table-column prop="isSuccessText" label="是否成功" min-width="120px" :key="Math.random()"></el-table-column>
        <el-table-column prop="orgBalance" label="操作前余额" min-width="120px" :key="Math.random()"></el-table-column>
        <el-table-column prop="finalBalance" label="操作后余额" min-width="120px" :key="Math.random()"></el-table-column>
        <el-table-column prop="modifier" label="操作人" min-width="120px" :key="Math.random()"></el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'Record',
  components: {
    Pagination
  },
  data () {
    return {
      startDay: '',
      endDay: '',
      queryType: '',
      typeData: [
        {id: '', name: '不限'},
        {id: 1, name: '充值'},
        {id: 2, name: '退款'}
      ],
      thisModule: null,
      isLoading: false,
      tableData: [{}]
    }
  },
  created () {
    this.thisModule = this.myOption.requestModule.user.children.adOwner.children.balanceDetail
    this.getList()
  },
  methods: {
    close () {
      this.$router.push({
        path: this.$route.path.replace('/record', '/list')
      })
    },
    // 获取列表
    getList () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.api,
        data: this.qs.stringify({
          advertiserId: this.$store.state.user.editId,
          startDate: this.startDay,
          endDate: this.endDay,
          type: this.queryType,
          startPage: this.$store.state.user.currentPage,
          pageSize: this.$store.state.user.pageSize
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          for (let val of data) {
            val.typeText = val.type === 1 ? '充值' : '退款'
            val.isSuccessText = val.isSuccess === 1 ? '成功' : '失败'
          }
          this.tableData = res.data.data.data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ad_owner/Record.vue